import i18n
	from "../i18n/i18n";

export default class math {
	constructor() {
		this.language = i18n.language.substr(0, 2)
		this.characters = [];
		const languages = {
			de: require('../data/de/math.json'),
			en: require('../data/en/math.json')
		};
		this.characters = languages[this.language];
	}

	getCategories() {
		return this.characters.systems.math.categories;
	}

	getCharactersByCategory(category) {
		var result = {};
		for (let key in this.characters.systems.math.categories) {
			if (key === category.toString() && key) {
				let characterList = this.characters.systems.math.categories[key];
				for (let key2 in characterList.content) {
					result[key2] = characterList.content[key2];
				}
			}
		}
		return result;
	}
}